import { isSsr } from 'HelperFunctions/ssr';

export const isMobile = () => {
  if (isSsr) {
    return false;
  } else {
    return window.innerWidth <= 800;
  }
};
